import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-burger-icon',
  templateUrl: './burger-icon.component.html',
  styleUrls: ['./burger-icon.component.scss']
})
export class BurgerIconComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
